export default __webpack_public_path__ + "static/media/star.1b51659f.svg";